export enum CategoriesProperty {
  id = '_id',
  name = 'name',
  category_url = 'category_url',
  order_number = 'order_number',
  size = 'size',
  color_code = 'color_code',
}
